import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";

@Injectable()
export class Globals {

    private errorToast: any = "";
    private successToast: any = "";
    private variables: any = {
        loginResponse: {}
    }
    constructor(private router: Router) {
        this.errorToast = document.getElementById("errorToast");
        this.successToast = document.getElementById("successToast");
    }

    // get getVariable(key) { 
    //     return this.variables[key];
    // }
    async presentErrorToast(_msg) {
        if (!this.errorToast) {
            this.errorToast = document.getElementById("errorToast");
        }
        this.errorToast.innerHTML = _msg;
        this.errorToast.style.display = "block";
        setTimeout(() => {
            this.errorToast.style.display = "none";
            this.errorToast.innerHTML = "";
        }, 3000);
    }
    async presentSuccessToast(_msg) {
        if (!this.successToast) {
            this.successToast = document.getElementById("successToast");
        }
        this.successToast.innerHTML = _msg;
        this.successToast.style.display = "block";
        setTimeout(() => {
            this.successToast.style.display = "none";
            this.successToast.innerHTML = "";
        }, 3000);
    }

    getUserPrivilages() {
        return [
            { "name": "Dashboard", isHeader: true },
            { "name": "DASHBOARD_VIEW", "description": "View Dashboard", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "DASHBOARD_VIEW", "description": "View Dashboard", "descriptionAr": null, isHeader: false, isHidden: true },
            { "name": "Gate Access", isHeader: true },
            { "name": "GATE_ACCESS_VIEW", "description": "View Gate Access", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "GATE_ACCESS_EDIT", "description": "Edit Gate Access", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Access Card", isHeader: true },
            { "name": "ACCESS_CARD_VIEW", "description": "View Access Card", "descriptionAr": "عرض بطاقات الدخول", isHeader: false, isHidden: false },
            { "name": "ACCESS_CARD_EDIT", "description": "Edit Access Card", "descriptionAr": "تعديل بطاقات الدخول", isHeader: false, isHidden: false },
            { "name": "Complaints", isHeader: true },
            { "name": "CS_COMPLAIN_VIEW", "description": "View All Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "CS_COMPLAIN_EDIT", "description": "Edit All Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Agriculture Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_AGRICULTURE_VIEW", "description": "View Agriculture Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_AGRICULTURE_EDIT", "description": "Edit Agriculture Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Engineering Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_ENGINEERING_VIEW", "description": "View Engineering Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_ENGINEERING_EDIT", "description": "Edit Engineering Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Environment Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_ENVIRONMENT_VIEW", "description": "View Environment Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_ENVIRONMENT_EDIT", "description": "Edit Environment Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Financial Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_FINANCIAL_VIEW", "description": "View Financial Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_FINANCIAL_EDIT", "description": "Edit Financial Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Maintenance Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_MAINTENANCE_VIEW", "description": "View Maintenance Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_MAINTENANCE_EDIT", "description": "Edit Maintenance Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Security Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_SECURITY_VIEW", "description": "View Security Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_SECURITY_EDIT", "description": "Edit Security Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Transportation Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_TRANSPORTATION_VIEW", "description": "View Transportation Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_TRANSPORTATION_EDIT", "description": "Edit Transportation Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Other Complaints", isHeader: true, isHidden: true },
            { "name": "COMPLAIN_OTHER_VIEW", "description": "View Other Complaints", "descriptionAr": "عرض جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "COMPLAIN_OTHER_EDIT", "description": "Edit Other Complaints", "descriptionAr": "تعديل جميع الشكاوى", isHeader: false, isHidden: false },
            { "name": "Projects", isHeader: true },
            { "name": "PROJECTS_VIEW", "description": "View Projects", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "PROJECTS_EDIT", "description": "Edit Projects", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Properties", isHeader: true },
            { "name": "PROPERTY_VIEW", "description": "View Property", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "PROPERTY_EDIT", "description": "Edit Property", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "SOS", isHeader: true },
            { "name": "SOS_VIEW", "description": "View SOS", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "SOS_VIEW", "description": "View SOS", "descriptionAr": null, isHeader: false, isHidden: true },
            { "name": "Operations Orders", isHeader: true },
            { "name": "ORDERS_VIEW", "description": "View Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "ORDERS_EDIT", "description": "Edit Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Agent Orders", isHeader: true },
            { "name": "CS_ORDERS_VIEW", "description": "View Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "CS_ORDERS_EDIT", "description": "Edit Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Operations Cust Orders", isHeader: true },
            { "name": "CUSTOMIZED_ORDERS_VIEW", "description": "View Customized Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "CUSTOMIZED_ORDERS_EDIT", "description": "Edit Customized Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Agent Cust Orders", isHeader: true },
            { "name": "CS_CUSTOMIZED_ORDERS_VIEW", "description": "View Customized Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "CS_CUSTOMIZED_ORDERS_EDIT", "description": "Edit Customized Orders", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Users", isHeader: true },
            { "name": "USERS_VIEW", "description": "View Users", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "USERS_EDIT", "description": "Edit Users", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Subscriptions", isHeader: true },
            { "name": "SUBSCRIPTION_VIEW", "description": "View Subscriptions", "descriptionAr": "عرض الاشتراكات", isHeader: false, isHidden: false },
            { "name": "SUBSCRIPTION_EDIT", "description": "Edit Subscriptions", "descriptionAr": "تعديل الاشتراكات", isHeader: false, isHidden: false },
            { "name": "Subscription Categories", isHeader: true },
            { "name": "SUBSCRIPTION_CATEGORY_VIEW", "description": "View Category", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "SUBSCRIPTION_CATEGORY_EDIT", "description": "Edit Category", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Services", isHeader: true },
            { "name": "SERVICE_VIEW", "description": "View Service", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "SERVICE_EDIT", "description": "Edit Service", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Offers", isHeader: true },
            { "name": "OFFERS_VIEW", "description": "View Offers", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "OFFERS_EDIT", "description": "Edit Offers", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Timelines", isHeader: true },
            { "name": "TIMELINES_VIEW", "description": "View Timelines", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "TIMELINES_EDIT", "description": "Edit Timelines", "descriptionAr": null, isHeader: false, isHidden: false },
            { "name": "Notifications", isHeader: true },
            { "name": "NOTIFICATIONS_SEND", "description": "Send Notifications", "descriptionAr": null, isHeader: false, isHidden: false },
        ]
    }

    notPermittedLogin() {
        this.router.navigate(["login"]).then(res => {
            this.presentErrorToast("Sorry, you aren`t permitted to use this website");
        });
    }

    getRouting(name) {
        switch (name) {
            case "DASHBOARD_VIEW":
                return "Dashboard";
            case "GATE_ACCESS_VIEW":
            case "GATE_ACCESS_EDIT":
                return "gateAccess";
            case "ACCESS_CARD_VIEW":
            case "ACCESS_CARD_EDIT":
                return "access-card";
            case "PROJECTS_VIEW":
            case "PROJECTS_EDIT":
                return "projects";
            case "ORDERS_VIEW":
            case "ORDERS_EDIT":
                return "orders";
            case "CUSTOMIZED_ORDERS_VIEW":
            case "CUSTOMIZED_ORDERS_EDIT":
                return "customized-orders";
            case "USERS_VIEW":
            case "USERS_EDIT":
                return "users";
            case "SUBSCRIPTION_VIEW":
            case "SUBSCRIPTION_EDIT":
                return "subscription";
            case "SUBSCRIPTION_CATEGORY_VIEW":
            case "SUBSCRIPTION_CATEGORY_EDIT":
                return "subscription-Catg";
            case "SERVICE_VIEW":
            case "SERVICE_EDIT":
                return "customized-service";
            case "OFFERS_VIEW":
            case "OFFERS_EDIT":
                return "offers";
            case "CS_ORDERS_VIEW":
            case "CS_ORDERS_EDIT":
                return "cuOrders";
            case "CS_CUSTOMIZED_ORDERS_VIEW":
            case "CS_CUSTOMIZED_ORDERS_EDIT":
                return "CuCustomized-orders";
            case "NOTIFICATIONS_SEND":
                return "send-Notification";
            case "CS_COMPLAIN_VIEW":
            case "CS_COMPLAIN_EDIT":
                return "complaints";
            case "COMPLAIN_AGRICULTURE_VIEW":
            case "COMPLAIN_AGRICULTURE_EDIT":
                return "complaints-agriculture";
            case "COMPLAIN_ENGINEERING_VIEW":
            case "COMPLAIN_ENGINEERING_EDIT":
                return "complaints-engineering";
            case "COMPLAIN_ENVIRONMENT_VIEW":
            case "COMPLAIN_ENVIRONMENT_EDIT":
                return "complaints-environment";
            case "COMPLAIN_FINANCIAL_VIEW":
            case "COMPLAIN_FINANCIAL_EDIT":
                return "complaints-financial";
            case "COMPLAIN_MAINTENANCE_VIEW":
            case "COMPLAIN_MAINTENANCE_EDIT":
                return "complaints-maintenance";
            case "COMPLAIN_SECURITY_VIEW":
            case "COMPLAIN_SECURITY_EDIT":
                return "complaints-security";
            case "COMPLAIN_TRANSPORTATION_VIEW":
            case "COMPLAIN_TRANSPORTATION_EDIT":
                return "complaints-transportation";
            case "COMPLAIN_OTHER_VIEW":
            case "COMPLAIN_OTHER_EDIT":
                return "complaints-others";
            case "TIMELINES_VIEW":
            case "TIMELINES_EDIT":
                return "timeline";
            case "SOS_VIEW":
                return "sos";
        }
    }

    formateDate(_date) {
        var date = new Date(_date);
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return date.getFullYear() + "-" + (month.toString().length > 1 ? month : "0" + month) + "-" + (day.toString().length > 1 ? day : "0" + day);
    }

    transformDate(date, format) {
        var datePipe = new DatePipe("en");
        return datePipe.transform(
            date,
            format
        );
    }

    getComplainsDepartments(addAll = false) {
        let departments = [];
        departments = [
            { id: "agriculture", name: 'complains.agriculture' },
            { id: "engineering", name: 'complains.engineering' },
            { id: "environment", name: 'complains.environment' },
            { id: "financial", name: 'complains.financial' },
            { id: "maintenance", name: 'complains.maintenance' },
            { id: "security", name: 'complains.security' },
            { id: "transportation", name: "complains.transportation" },
            { id: "other", name: 'complains.other' },
        ];
        if (addAll) {
            departments.unshift({ id: "", name: "general.all" });
        }
        return departments;
    }

    getComplainsSubDepartments(type, ignoreAll = false) {
        let subDepartments = [];
        switch (type) {
            case "agriculture":
                subDepartments = [{ id: 'subscription', name: 'complains.agri-sub' }, { id: 'order', name: 'complains.agri-order' }];
                break;
            case "maintenance":
                subDepartments = [{ id: 'aluminum', name: 'complains.main-aluminum' }, { id: 'ac', name: 'complains.main-ac' },
                { id: 'satellite', name: 'complains.main-satellite' }, { id: 'plumbing', name: 'complains.main-plumbing' },
                { id: 'carpentry', name: 'complains.main-carpentry' }, { id: 'electricity', name: 'complains.main-electricity' },
                { id: 'swimming', name: 'complains.main-swimming' }];
                break;
            case "security":
                subDepartments = [{ id: 'newspaper', name: 'complains.sec-newspaper' }];
                break;
            case "transportation":
                subDepartments = [{ id: 'internal', name: 'complains.trans-internal' }];
                break;
            case "environment":
                subDepartments = [{ id: 'house', name: 'complains.env-house' }, { id: 'car', name: 'complains.env-car' },
                { id: 'pest', name: 'complains.env-pest' }, { id: 'luggage', name: 'complains.env-luggage' },
                { id: 'gas', name: 'complains.env-gas' },
                { id: 'removing', name: 'complains.env-removing' }, { id: 'agriculture', name: 'complains.env-agre' }];
                break;
        }
        if (!ignoreAll) {
            subDepartments.unshift({ id: "", name: "general.all" });
        }
        return subDepartments;
    }

    getComplainsStatus(isAgent = true) {
        if (isAgent) {
            return [
                { id: "OPEN", name: "general.open" },
                { id: "UNDER_INVESTIGATION", name: "general.underInvestigation" },
                { id: "CONFIRM_SATISFACTION", name: "general.confirmSatisfaction" },
                { id: 'CLOSED', name: 'general.closed' }
            ];
        }
        else {
            return [
                { id: "UNDER_INVESTIGATION", name: "general.underInvestigation" },
                { id: "CONFIRM_SATISFACTION", name: "general.completed" },
            ];
        }
    }

    getComplainStatusForUpdate(currentStatus) {
        switch (currentStatus) {
            case "OPEN":
                return "UNDER_INVESTIGATION";
            case "UNDER_INVESTIGATION":
                return "CONFIRM_SATISFACTION";
            case "CONFIRM_SATISFACTION":
                return "CLOSED";
        }
    }

    dataURItoBlob(dataURI: any) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString: any;
        if (dataURI.split(",")[0].indexOf("base64") >= 0) {
            byteString = atob(dataURI.split(",")[1]);
        } else {
            byteString = unescape(dataURI.split(",")[1]);
        }
        // separate out the mime component
        const mimeString = dataURI
            .split(",")[0]
            .split(":")[1]
            .split(";")[0];
        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], { type: mimeString });
    }
}